9
<template>
  <div id="nav">
    <div class="v_banxin">
      <div class="flex">
        <div class="v_left">
          <div class="v_lefttop">
            <div class="v_lefttopin">
              <img src="../assets/img/shangpinfenlei.png" alt="" class="v_lefttopimg">
              <span :class="{v_active:active,v_size:move}" :style="{fontSize:nunsize}">{{fullneme}}</span>
            </div>
            <div :class="{v_leftbtn:true,block:toshow}">
              <div v-for="(item,index) in errlist.list" :key="index">
                <div class="v_leftbtnlist flex">
                  <div class="v_leftbtnlistleft">
                    <img :src="https + item.icon_o" class="star">
                    <img :src="https + item.icon_t" class="over">
                    <span :title="item.name">{{item.name}}</span>
                  </div>
                  <div class="v_leftbtnlistright flex">
                    <div class="v_leftbtnlistrightleft">
                      <div class="v_navlist flex" v-for="(_item,index) in item.childlist" :key="index">
                        <div class="v_navlistleft" @click="jumpFn2(item.id,_item.id)">
                          {{_item.name}} >
                        </div>
                        <div class="v_navlistright">
                          <router-link :to="{path:'/seemore', query:{firstid:item.id,twoid:_item.id,id:_items.id}}" target="_blank" class="v_navlistrightson" v-for="(_items,index) in _item.childlist" :key="index">
                            {{_items.name}}
                          </router-link>
                        </div>
                      </div>
                    </div>
                    <div class="v_leftbtnlistrightright flex flex_warp">
                      <router-link :to="{path:'/brandinner', query:{ id:_itemimg.brand_id }}" class="v_listrigtlink" v-for="(_itemimg,index) in item.brands" :key="index" v-if="index < 12">
                        <span class="v_listrigtlink_img"><img :src="https + _itemimg.brand_cover" alt="" :title="_itemimg.brand_name"></span>
                        <span class="v_listrigtlink_span txtnowarp">{{_itemimg.brand_name}}</span>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="v_right">
          <tabbar>
            <tabitem link="/index" biaoshi="" v-on:routerpath="receive" class="v_righttab">
              <div slot="item-txt" class="tab-txt">首页</div>
            </tabitem>

            <tabitem link="/brand" biaoshi="" v-on:routerpath="receive" class="v_righttab">
              <div slot="item-txt" class="tab-txt">品牌馆</div>
            </tabitem>
            <tabitem :link="'/changjing?label=' + item.label" v-for="(item,index) in navlists" :key="index" :biaoshi="item.label" v-on:routerpath="receive" class="v_righttab">
              <div slot="item-txt" class="tab-txt">{{item.title}}</div>
            </tabitem>
            <!--<tabitem link="/schollopen" biaoshi="2" v-on:routerpath="receive" class="v_righttab">
              <div slot="item-txt" class="tab-txt">开学必备</div>
            </tabitem>-->
          </tabbar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tabbar from '@/components/tab/tabbar.vue'
import tabitem from '@/components/tab/tabitem.vue'
import qs from "qs";

export default {
  data() {
    return {
      shopobjlist: [{

      }],
      active: false,
      move: false,
      nunsize: "20px",
      lastname: '分类',
      fastname: '商品',
      navlist: [],
      https: '',
      toshow: false,
      navlists: [],
    }
  },
  props: {
    errlist: {
      // type:Array,
      default() {
        return [];
      }
    },

  },
  watch: {
    '$route'(to, from) { //监听路由是否变化
      let that = this;

      if (that.$route.query) { //判断id是否有值
        that.$router.go(0)

      }
    }
  },
  components: {
    tabbar,
    tabitem
  },
  beforeCreate() {

  },

  created() {
    let that = this;
    that.https = that.$publicUrl.http1;
    that.changjingFn();


  },
  methods: {
    // 父组件中响应子组件自定义的方法
    // 此函方法的参数是用来接收从子组件传递来的数据
    // 子组件传递了几个数据，这里就有几个参数
    receive(val_1) {
      let that = this;
      if (val_1 == '/indexinner') {
        that.toshow = true
      } else {
        that.toshow = false
      }

    },
    changjingFn() {
      let that = this;
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.goodssceneslists,
        data: qs.stringify({})
      })
        .then(function (response) {
          let data = response.data;
          if (data.stateCode == 10000) {
            that.navlists = data.data

          } else {

          }
        })
        .catch(function (error) { });
    },
    jumpFn1(id) {
      let that = this;
      that.$router.push({
        path: '/seemore',
        query: {
          firstid: id,
        },

      })
    },
    jumpFn2(id, id2) {
      let that = this;
      that.$router.push({
        path: '/seemore',
        query: {
          firstid: id,
          twoid: id2,
        },

      })
    },
  },
  mounted() { },
  computed: {
    //计算属性 对数据进行整合
    fullneme: function () {
      //          	console.log(this.fastname)
      //          	console.log(this.lastname)
      return this.fastname + this.lastname
    }
  },
}
</script>
<style scoped>
.flex {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: flex-start;
  /*是否继承父元素高度*/
}

.flex_warp {
  -webkit-box-lines: multiple;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
  box-sizing: border-box;
  align-content: flex-start;
}

.flex_w_center {
  justify-content: center;
}

.flex_h_center {
  align-items: baseline;
}

.flex_w_center1 {
  justify-content: space-between;
}

.flex_w_space_around {
  justify-content: space-around;
}

#nav {
  width: 100%;
  height: 60px;
  background-color: #dc1e33;
}

.v_active {
  color: green;
}

.v_size:hover {
  margin-left: 20px;
}

.v_banxin {
  width: 1200px;
  display: block;
  margin: 0 auto;
}

.v_left {
  width: 220px;
  padding-left: 40px;
}

.v_lefttop {
  width: 100%;
  box-sizing: border-box;
  background-color: #dc1e33;
  color: #ffffff;
  font-size: 20px;
  line-height: 24px;
}

.v_lefttopin {
  padding: 15px 20px;
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  cursor: pointer;
}

.v_lefttopin span {
  vertical-align: top;
  display: inline-block;
  height: 30px;
  line-height: 30px;
  width: calc(100% - 45px);
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v_lefttopimg {
  width: 30px;
  height: 30px;
  margin-right: 15px;
  object-fit: scale-down;
  display: inline-block;
}

.v_leftbtn {
  width: 180px;
  background-color: #dc4353;
  z-index: 100;
  position: relative;
  box-sizing: border-box;
  /* padding: 10px 0; */
  display: none;
}

.v_right {
  width: 940px;
  height: 60px;
}

.v_righttab {
  box-sizing: border-box;
  color: #ffffff;
  font-size: 20px;
  cursor: pointer;
}

.v_leftbtnlist {
  width: 100%;
}

.v_leftbtnlistleft {
  width: 220px;
  /* height: 60px; */
  padding: 5px 20px;
  padding-left: 30px;
  box-sizing: border-box;
  cursor: pointer;
}

.v_leftbtnlistleft img {
  width: 20px;
  height: 30px;
  object-fit: scale-down;
  margin-right: 15px;
  vertical-align: top;
  display: inline-block;
}

.v_leftbtnlistleft span {
  vertical-align: top;
  display: inline-block;
  height: 30px;
  line-height: 30px;
  width: calc(100% - 45px);
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v_leftbtnlistright {
  display: none;
  height: 520px;
  overflow: hidden;
}

.v_leftbtnlistright {
  width: 980px;
  position: absolute;
  top: 0px;
  left: 180px;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 15px;
  padding-top: 0;
  display: none;
}

.v_leftbtnlistrightleft {
  width: 745px;
  min-height: 300px;
  box-sizing: border-box;
  padding-right: 10px;
}

.v_navlist {
  width: 100%;
  border-bottom: 1px solid #dddddd;
  /*height: 50px;*/
  min-height: 40px;
}

.v_navlistleft {
  width: 120px;
  box-sizing: border-box;
  line-height: 40px;
  font-size: 16px;
  color: #333333;
  cursor: pointer;
}

.v_navlistright {
  width: calc(100% - 120px);
  box-sizing: border-box;
}

.v_navlistrightson {
  font-size: 14px;
  box-sizing: border-box;
  padding: 0 15px;
  color: #666666;
  position: relative;
  line-height: 40px;
  display: inline-block;
}

.v_navlistrightson:after {
  content: " ";
  height: 12px;
  width: 1px;
  background-color: #666666;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.v_navlistrightson:hover {
  color: #dc4353;
}

.v_navlistrightson:hover::after {
  background-color: #dc4353;
}

.v_leftbtnlistrightright {
  width: 205px;
  height: 300px;
}

.v_listrigtlink {
  /*border: 1px solid #eeeeee;*/
  width: 85px;
  height: 65px;
  display: block;
  margin-left: 15px;
  margin-bottom: 5px;
  margin-top: 10px;
}

.v_listrigtlink_img {
  display: inline-block;
  border: 1px solid #eeeeee;
  width: 85px;
  height: 45px;
  display: block;
}

.v_listrigtlink img {
  display: block;
  width: 85px;
  height: 45px;
  object-fit: scale-down;
}

.v_listrigtlink_span {
  font-size: 13px;
  color: #333333;
  display: inline-block;
  width: 85px;
  margin-top: 6px;
  /*line-height: 20px;*/
  text-align: center;
}

.v_leftbtnlistleft .over {
  display: none;
}

.v_leftbtnlist:hover .v_leftbtnlistleft .over {
  display: inline-block;
}

.v_leftbtnlist:hover {
  background-color: #ffffff;
}

.v_leftbtnlist:hover .v_leftbtnlistleft .star {
  display: none;
}

.v_leftbtnlist:hover .v_leftbtnlistleft {
  color: #dc4353;
}

.v_leftbtnlist:hover .v_leftbtnlistright {
  display: flex;
}

.v_lefttop:hover .v_leftbtn {
  display: block;
}

.block {
  display: block !important;
}
</style>